import * as yup from "yup";

const NewLocationAccount = yup.object().shape({
  name: yup.string().max(40, 'The field cant have more than 40 characters').required(),
  street: yup.string().max(40, 'The field cant have more than 40 characters').required(),
});

export default NewLocationAccount;
